// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindSkill } from "../schema";

export function serialize_KindSkill_internal(value: KindSkill): unknown {
  return ((value: "skill"): unknown => {
    return value;
  })(value);
}
export function serialize_KindSkill(obj: KindSkill): string {
  return renderJsonWithNumbersAsBigint(serialize_KindSkill_internal(obj));
}
export function deserialize_KindSkill_internal(value: unknown): ParserResult<KindSkill> {
  return ((value: unknown): ParserResult<"skill"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "skill":
        return { success: true, value: "skill" };
      default:
        return { success: false, reason: `[#/components/schemas/KindSkill]: '${value}' expected to be enum, one of 'skill'.` };
    }
  })(value);
}
export function deserialize_KindSkill(str: string): ParserResult<KindSkill> {
  return deserialize_KindSkill_internal(parseJsonWithNumbersAsBigint(str));
}
